(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/reducers/reducer.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/reducers/reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function getMarksByBoardData(boardData) {
  const newMarks = [[false, false, false, false, false]];
  if (Array.isArray(boardData)) {
    boardData.forEach(marks => {
      const splitMarks = marks.split('');
      const calculatedMarks = [];
      calculatedMarks.push(false);
      calculatedMarks.push(splitMarks.indexOf('1') > -1);
      calculatedMarks.push(splitMarks.indexOf('X') > -1);
      calculatedMarks.push(false);
      calculatedMarks.push(splitMarks.indexOf('2') > -1);
      newMarks.push(calculatedMarks);
    });
  }
  return newMarks;
}
function getDrawEventsAfterSelectAlternative(coupon, action) {
  return coupon.drawEvents.map((drawEvent, index) => {
    if (index === action.rowNumber) {
      return drawEvent.map((alternative, index) => {
        if (index === action.outcomeNumber) {
          return !alternative;
        }
        return alternative;
      });
    }
    return drawEvent;
  });
}
function getNumberOfHalfHedges(drawEvents) {
  return drawEvents.reduce((acc, drawEvent) => {
    const marks = drawEvent.filter(mark => mark === true);
    if (marks.length === 2) {
      acc += 1;
    }
    return acc;
  }, 0);
}
function getNumberOfFullHedges(drawEvents) {
  return drawEvents.reduce((acc, drawEvent) => {
    const marks = drawEvent.filter(mark => mark === true);
    if (marks.length === 3) {
      acc += 1;
    }
    return acc;
  }, 0);
}
function validateCoupon(coupon) {
  let valid = true;
  for (let i = 1; i < coupon.drawEvents.length; i++) {
    valid = valid && coupon.drawEvents[i].indexOf(true) > -1 && coupon.betSum <= svs.challenge.constants.MAX_COUPON_PRICE;
  }
  coupon.isPayable = valid;
  return coupon;
}
function getBetsum(rowPrice, halfHedges, fullHedges) {
  return rowPrice * (halfHedges > 0 ? 2 ** halfHedges : 1) * (fullHedges > 0 ? 3 ** fullHedges : 1);
}
function getSystemType(halfHedges, fullHedges) {
  return fullHedges > 0 || halfHedges > 0 ? 'MSYS' : 'SROW';
}

function calculateBaseRow(originalBaseRow, updatedRowNumber, updatedOutcomeNumber) {
  let baseRow = originalBaseRow;
  if (!baseRow) {
    baseRow = {};
  }
  if (!baseRow[updatedRowNumber]) {
    baseRow[updatedRowNumber] = {};
  }
  if (baseRow[updatedRowNumber][updatedOutcomeNumber]) {
    baseRow[updatedRowNumber][updatedOutcomeNumber] = undefined;
    let isRowEmpty = true;
    for (const prop in baseRow[updatedRowNumber]) {
      if (Object.prototype.hasOwnProperty.call(baseRow[updatedRowNumber], prop)) {
        if (baseRow[updatedRowNumber][prop]) {
          isRowEmpty = false;
        }
      }
    }
    if (isRowEmpty) {
      delete baseRow[updatedRowNumber];
    }
  } else {
    baseRow[updatedRowNumber][updatedOutcomeNumber] = true;
  }

  let halfHedgesBaseRow = 0;
  let fullHedgesBaseRow = 0;
  for (const prop in baseRow) {
    if (Object.prototype.hasOwnProperty.call(baseRow, prop) && baseRow[prop] && prop !== 'halfHedges' && prop !== 'fullHedges') {
      let noOfMarks = 0;
      if (baseRow[prop][1]) {
        ++noOfMarks;
      }
      if (baseRow[prop][2]) {
        ++noOfMarks;
      }
      if (baseRow[prop][4]) {
        ++noOfMarks;
      }
      if (noOfMarks === 3) {
        ++fullHedgesBaseRow;
      } else if (noOfMarks === 2) {
        ++halfHedgesBaseRow;
      }
    }
  }
  delete baseRow.halfHedges;
  delete baseRow.fullHedges;
  if (!_.isEmpty(baseRow)) {
    baseRow.halfHedges = halfHedgesBaseRow;
    baseRow.fullHedges = fullHedgesBaseRow;
  }
  return baseRow;
}

function isPartOfBaseRow(baseRow, rowNumber, outcomeNumber) {
  if (baseRow) {
    for (const prop in baseRow) {
      if (Object.prototype.hasOwnProperty.call(baseRow, prop) && parseInt(prop, 10) === parseInt(rowNumber, 10) && prop !== 'halfHedges' && prop !== 'fullHedges') {
        return baseRow[prop][outcomeNumber];
      }
    }
  }
  return false;
}

svs.challenge.reducers.Reducer = function () {
  var _action$accountBalanc;
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case svs.challenge.actions.SELECT_ALTERNATIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        coupons: state.coupons.map(coupon => {
          if (coupon.drawNumber === action.drawNumber) {
            const newDrawEvents = getDrawEventsAfterSelectAlternative(coupon, action);
            const halfHedges = getNumberOfHalfHedges(newDrawEvents);
            const fullHedges = getNumberOfFullHedges(newDrawEvents);
            const betSum = getBetsum(coupon.chosenBetPrice, halfHedges, fullHedges);
            let baseRow = coupon.baseRow;

            if (action.isChecking || isPartOfBaseRow(coupon.baseRow, action.rowNumber, action.outcomeNumber)) {
              baseRow = calculateBaseRow(coupon.baseRow, action.rowNumber, action.outcomeNumber);
            }
            const newCoupon = _objectSpread(_objectSpread({}, coupon), {}, {
              baseRow,
              betSum,
              drawEvents: newDrawEvents,
              fullHedges,
              halfHedges,
              systemType: getSystemType(halfHedges, fullHedges),
              xpertenMode: coupon.xpertenMode === 'WEIGHTEDQP' || coupon.xpertenMode === 'PARTIALQP' ? 'MODIFIEDQP' : coupon.xpertenMode
            });
            validateCoupon(newCoupon);
            return newCoupon;
          }
          return coupon;
        })
      });
    case svs.challenge.actions.SELECT_BET_AMOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        coupons: state.coupons.map(coupon => {
          if (coupon.drawNumber === action.drawNumber) {
            const newDrawEvents = getDrawEventsAfterSelectAlternative(coupon, action);
            const halfHedges = getNumberOfHalfHedges(newDrawEvents);
            const fullHedges = getNumberOfFullHedges(newDrawEvents);
            const newCoupon = _objectSpread(_objectSpread({}, coupon), {}, {
              betSum: getBetsum(action.chosenBetPrice, halfHedges, fullHedges),
              chosenBetPrice: action.chosenBetPrice
            });
            validateCoupon(newCoupon);
            return newCoupon;
          }
          return coupon;
        })
      });
    case svs.challenge.actions.LOAD_LOCALSTORAGE:
      {
        const existingCoupons = Object.keys(action.data).reduce((acc, key) => {
          const draw = svs.challenge.helpers.getDrawByDrawNumber(parseInt(key, 10), state);
          if (draw) {
            acc[key] = action.data[key];
          }
          return acc;
        }, {});
        const coupons = state.coupons.map(coupon => {
          if (existingCoupons[coupon.drawNumber]) {
            const localStorageCoupon = existingCoupons[coupon.drawNumber];
            const drawEvents = getMarksByBoardData(localStorageCoupon.boardData);
            const halfHedges = getNumberOfHalfHedges(drawEvents);
            const fullHedges = getNumberOfFullHedges(drawEvents);
            const newCoupon = _objectSpread(_objectSpread({}, coupon), {}, {
              baseRow: localStorageCoupon.baseRow,
              betSum: getBetsum(localStorageCoupon.selectedRowPrice, halfHedges, fullHedges),
              chosenBetPrice: localStorageCoupon.selectedRowPrice,
              drawEvents,
              fullHedges,
              halfHedges,
              hasActionbar: localStorageCoupon.hasActionbar,
              systemType: getSystemType(halfHedges, fullHedges),
              xperten: localStorageCoupon.xperten,
              xpertenMode: localStorageCoupon.xpertenMode
            });
            validateCoupon(newCoupon);
            return newCoupon;
          }
          return coupon;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons
        });
      }
    case svs.challenge.actions.URL_PARAMETERS:
      {
        const querySigns = action.querySigns;
        const formattedSigns = [];
        const coupons = state.coupons.map(coupon => {
          if (coupon.drawNumber === action.drawNumber) {
            var _state$draws;
            const numberOfDrawEvents = ((_state$draws = state.draws) === null || _state$draws === void 0 || (_state$draws = _state$draws.find(draw => draw.drawNumber === action.drawNumber)) === null || _state$draws === void 0 || (_state$draws = _state$draws.drawEvents) === null || _state$draws === void 0 ? void 0 : _state$draws.length) || 0;
            const signs = querySigns.replaceAll(';', '').split(',');
            const selections = [];

            for (let i = 0; i < signs.length; i++) {
              const [eventNumber, eventSelections] = signs[i].split(':');
              selections[eventNumber - 1] = eventSelections;
            }

            for (let i = 0; i < numberOfDrawEvents; i++) {
              const currentSelection = selections[i];

              if (currentSelection) {
                formattedSigns[i] = currentSelection;
              } else {
                formattedSigns.push('');
              }
            }
            const boardData = formattedSigns.length > 0 ? formattedSigns : coupon.boardData;
            const drawEvents = getMarksByBoardData(boardData);
            const halfHedges = getNumberOfHalfHedges(drawEvents);
            const fullHedges = getNumberOfFullHedges(drawEvents);
            const newCoupon = _objectSpread(_objectSpread({}, coupon), {}, {
              betSum: getBetsum(coupon.chosenBetPrice, halfHedges, fullHedges),
              drawEvents,
              fullHedges,
              halfHedges,
              systemType: getSystemType(halfHedges, fullHedges)
            });
            validateCoupon(newCoupon);
            return newCoupon;
          }
          return coupon;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons
        });
      }
    case svs.challenge.actions.LOAD_SETTINGS_LOCALSTORAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: action.data.settings
      });
    case svs.challenge.actions.CLEAR_COUPON:
      {
        const {
          drawNumber
        } = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons: state.coupons.map(coupon => {
            if (coupon.drawNumber === drawNumber) {
              const baseRowPrice = parseFloat(svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state).rowPrice);
              return _objectSpread(_objectSpread({}, coupon), {}, {
                baseRow: {},
                betSum: getBetsum(baseRowPrice, 0, 0),
                chosenBetPrice: baseRowPrice,
                drawEvents: coupon.drawEvents.map(() => [false, false, false, false, false]),
                fullHedges: 0,
                halfHedges: 0,
                hasActionbar: undefined,
                isPayable: false,
                xperten: _objectSpread(_objectSpread({}, coupon.xperten), {}, {
                  isEditingBaseRow: undefined,
                  selectedXpert: undefined
                }),
                xpertenMode: undefined
              });
            }
            return coupon;
          })
        });
      }
    case svs.challenge.actions.LOGIN:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoggedIn: true
      });
    case svs.challenge.actions.LOGOUT:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountBalance: 0,
        isLoggedIn: undefined
      });
    case svs.challenge.actions.RECEIVE_ACCOUNT_BALANCE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountBalance: (_action$accountBalanc = action.accountBalance) === null || _action$accountBalanc === void 0 ? void 0 : _action$accountBalanc.toString(),
        userAccountBalance: action.accountBalance
      });
    case svs.challenge.actions.OPEN_SPELGUIDE:
      return _objectSpread(_objectSpread({}, state), {}, {
        openSpelguide: true
      });
    case svs.challenge.actions.CLOSE_SPELGUIDE:
      return _objectSpread(_objectSpread({}, state), {}, {
        openSpelguide: undefined
      });
    case svs.challenge.actions.OPEN_TIPSINFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        openTipsinfo: true
      });
    case svs.challenge.actions.CLOSE_TIPSINFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        openTipsinfo: undefined
      });
    case svs.challenge.actions.SET_TIPSINFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread({}, action.settings)
      });
    case svs.challenge.actions.CLOSE_ACTIONBAR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons: state.coupons.map(coupon => {
            if (coupon.drawNumber === action.drawNumber) {
              return _objectSpread(_objectSpread({}, coupon), {}, {
                hasActionbar: undefined,
                xperten: _objectSpread(_objectSpread({}, coupon.xperten), {}, {
                  isEditingBaseRow: undefined,
                  selectedXpert: undefined
                })
              });
            }
            return coupon;
          })
        });
      }
    case svs.challenge.actions.OPEN_XPERTEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        openXperten: true
      });
    case svs.challenge.actions.CLOSE_XPERTEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        openXperten: undefined
      });
    case svs.challenge.actions.CLEAR_BASE_ROW:
      return _objectSpread(_objectSpread({}, state), {}, {
        coupons: state.coupons.map(coupon => {
          if (coupon.drawNumber === action.drawNumber) {
            return _objectSpread(_objectSpread({}, coupon), {}, {
              baseRow: {}
            });
          }
          return coupon;
        })
      });
    case svs.challenge.actions.START_EDIT_BASE_ROW:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons: state.coupons.map(coupon => {
            if (coupon.drawNumber === action.drawNumber) {
              return _objectSpread(_objectSpread({}, coupon), {}, {
                xperten: _objectSpread(_objectSpread({}, coupon.xperten), {}, {
                  isEditingBaseRow: true,
                  selectedXpert: action.xpert
                })
              });
            }
            return coupon;
          })
        });
      }
    case svs.challenge.actions.FETCH_XPERTEN_SUCCESS:
      if (action.payload && action.payload.bets && Array.isArray(action.payload.bets) && action.payload.bets.length > 0) {
        const bet = action.payload.bets[0];
        const drawNumber = bet.drawNum;
        const marks = getMarksByBoardData(bet.game1X2Boards[0].boardData);
        return _objectSpread(_objectSpread({}, state), {}, {
          coupons: state.coupons.map(coupon => {
            if (coupon.drawNumber === drawNumber) {
              const newDrawEvents = coupon.drawEvents.map((drawEvent, index) => marks[index]);
              const baseRowPrice = parseFloat(svs.challenge.helpers.getDrawByDrawNumber(action.drawNumber, state).rowPrice);
              const halfHedges = getNumberOfHalfHedges(newDrawEvents);
              const fullHedges = getNumberOfFullHedges(newDrawEvents);
              return _objectSpread(_objectSpread({}, coupon), {}, {
                betSum: getBetsum(baseRowPrice, halfHedges, fullHedges),
                chosenBetPrice: baseRowPrice,
                drawEvents: newDrawEvents,
                fullHedges,
                halfHedges,
                hasActionbar: true,
                isPayable: true,
                systemType: getSystemType(halfHedges, fullHedges),
                xperten: _objectSpread(_objectSpread({}, coupon.xperten), {}, {
                  isEditingBaseRow: undefined,
                  selectedXpert: action.xpert
                }),
                xpertenMode: _.isEmpty(coupon.baseRow) ? 'WEIGHTEDQP' : 'PARTIALQP'
              });
            }
            return coupon;
          })
        });
      }
      return state;
    case svs.challenge.actions.PAYMENT_INITIATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPaymentInitialized: true,
        isOverviewOpen: false
      });
    case svs.challenge.actions.PAYMENT_CONFIRM:
    case svs.challenge.actions.PAYMENT_SUCCESS:
    case svs.challenge.actions.PAYMENT_FAILED:
    case svs.challenge.actions.PAYMENT_CANCEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPaymentInitialized: false
      });
    case svs.challenge.actions.ENTER_MATCH_DETAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        xperten: {}
      });
    case svs.challenge.actions.TOGGLE_OVERVIEW:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverviewOpen: !state.isOverviewOpen
      });
    case svs.challenge.actions.CLOSE_OVERVIEW:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverviewOpen: false
      });
    default:
      {
        return state;
      }
  }
};

 })(window);